import { customAxios } from '../../axios/CustomAxios';
import {myIpAddress} from "../../config";

/**
 * 휴가 수정
 * @param body
 * @returns {Promise<axios.AxiosResponse<any>>}
 * @constructor
 */
const WithdrawVacation =(body)=>{
    return customAxios.post(myIpAddress+'/vacation/vacationWithdraw', body);
}
export default WithdrawVacation;